import { render, staticRenderFns } from "./DetailsComponent.vue?vue&type=template&id=4960f772"
import script from "./DetailsComponent.vue?vue&type=script&lang=js"
export * from "./DetailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports